module.exports = __webpack_public_path__ + "img/document-accept-3.2426380d.svg";